import { generateActions } from 'redux-crud-resources';
import { CRUDABLE_RESOURCES } from '../constants';

export const CRUD_ACTIONS = generateActions(CRUDABLE_RESOURCES);

module.exports = {
  ...CRUD_ACTIONS,
  // events
  UPDATE_EDITING_EVENT: 'update editing event',
  RESET_RECRUITS_STATE: 'reset state',
  RESET_ALL_STATE: 'reset all state',

  // tourneys
  UPDATE_EDITING_TOURNEY: 'update editing tourney',
  UPDATE_EDITING_USER_TOURNEY: 'update editing user tourney',
  UPDATE_EDITING_FOLLOWED_TEAMS: 'update editing followed teams',
  UPDATE_EDITING_APPOINTMENT: 'update editing appointment',
  GET_ALL_USER_TOURNEYS: 'get all user tourneys',
  GET_ALL_USER_TOURNEYS_SUCCESS: 'success: get all user tourneys',
  GET_ALL_USER_TOURNEYS_ERROR: 'error: get all user tourneys',
  ASSIGN_USER_TOURNEYS: 'assign user tourneys',
  ASSIGN_USER_TOURNEYS_SUCCESS: 'success: assign user tourneys',
  ASSIGN_USER_TOURNEYS_ERROR: 'error: assign user tourneys',
  GET_TOURNEYS_FOLLOWED_TEAMS: 'get tourney followed teams',
  GET_TOURNEYS_FOLLOWED_TEAMS_SUCCESS: 'success: get tourney followed teams',
  GET_TOURNEYS_FOLLOWED_TEAMS_ERROR: 'error: get tourney followed teams',
  GET_ALL_TOURNEY_TEAMS: 'get all tourney teams',
  GET_ALL_TOURNEY_TEAMS_SUCCESS: 'success: get all tourney teams',
  GET_ALL_TOURNEY_TEAMS_ERROR: 'error: get all tourney teams',
  ASSIGN_FOLLOWED_TEAMS: 'assign followed teams',
  ASSIGN_FOLLOWED_TEAMS_SUCCESS: 'success: assign followed teams',
  ASSIGN_FOLLOWED_TEAMS_ERROR: 'error: assign followed teams',
  REMOVE_RECRUIT_FROM_APPOINTMENT: 'remove recruit from appointments',
  REMOVE_RECRUIT_FROM_APPOINTMENT_SUCCESS: 'success: remove recruit from appointments',
  REMOVE_RECRUIT_FROM_APPOINTMENT_ERROR: 'error: remove recruit from appointments',
  GET_RECRUIT_APPOINTMENTS_SUCCESS: 'success: get recruit appointments',
  CLEAR_HOME_CALENDAR_EVENTS_SUCCESS: 'success: clear home calendar events',
  GET_ALL_VENUES: 'get all venues',
  GET_ALL_VENUES_SUCCESS: 'success: get all venues',
  GET_ALL_VENUES_ERROR: 'error: get all venues',
  UPDATE_EDITING_GAMES: 'update editing games',
  UPDATE_EDITING_VENUE: 'update editing venue',
  BULK_SAVE_TOURNEY_UPDATE: 'bulk save tourney update',
  BULK_SAVE_TOURNEY_UPDATE_SUCCESS: 'success: bulk save tourney update',
  BULK_SAVE_TOURNEY_UPDATE_ERROR: 'error: bulk save tourney update',

  // identity
  LOGIN_USER: 'login user',
  LOGIN_USER_ERROR: 'error: login user',
  LOGIN_USER_SUCCESS: 'success: login user',
  RESET_PASSWORD: 'reset password',
  RESET_PASSWORD_ERROR: 'error: reset password',
  RESET_PASSWORD_SUCCESS: 'success: reset password',
  GET_ACCOUNT_INFO: 'get account info',
  GET_ACCOUNT_INFO_SUCCESS: 'success: get account info',
  GET_ACCOUNT_INFO_ERROR: 'error: get account info',

  // lists
  UPDATE_TOP20_LIST: 'update Top 20 List',
  UPDATE_TOP20_LIST_SUCCESS: 'success: update Top 20 List',
  UPDATE_TOP20_LIST_ERROR: 'error: update Top 20 List',
  UPDATE_EDITING_LIST: 'update editing List',

  // recruits
  DELETE_RECRUITS_ERROR: 'error: delete recruits',
  GET_TOP20_RECRUITS: 'get top 20 Recruits',
  GET_TOP20_RECRUITS_ERROR: 'error: get top 20 Recruits',
  GET_TOP20_RECRUITS_SUCCESS: 'success: get top 20 Recruits',
  DELETE_ALL_RECRUITS: 'delete All Recruits',
  DELETE_ALL_RECRUITS_SUCCESS: 'success: delete All Recruits',
  DELETE_ALL_RECRUITS_ERROR: 'error: delete All Recruits',

  // schools
  REPORT_SCHOOL: 'report school',
  REPORT_SCHOOL_ERROR: 'error: report school',
  REPORT_SCHOOL_SUCCESS: 'success: report school',

  // tasks
  COMPLETE_TASK: 'complete task',
  COMPLETE_TASK_SUCCESS: 'success: complete task',
  COMPLETE_TASK_ERROR: 'error: complete task',
  UPDATE_EDITING_TASK: 'update editing task',


  // Manage List
  GET_LIST_RECRUITS_SUCCESS: 'success: get list Recruits',
  GET_LIST_RECRUITS: 'get list Recruits',
  GET_LIST_RECRUITS_ERROR: 'error: get list Recruits',

  // sessions
  GET_ALL_SESSIONS_SUCCESS: 'success: get all sessions',
  GET_ALL_SESSIONS: 'get all sessions',
  GET_ALL_SESSIONS_ERROR: 'error: get all sessions',

  // schedule-import-client
  GET_PROCESSED_DATA_SUCCESS: 'success: get processed data',
  GET_PROCESSED_DATA_ERROR: 'error: get processed data',
  GET_PROCESSED_DATA: 'get processed data',
  DELETE_SCRAPE_JOB: 'delete scrape job',
  DELETE_SCRAPE_JOB_SUCCESS: 'success: delete scrape job',
  DELETE_SCRAPE_JOB_ERROR: 'error: delete scrape job',
};


// WEBPACK FOOTER //
// ./src/js/FastRecruit/actions/index.js